<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xml:space="preserve"
        :width="width"
        :height="height"
        version="1.1"
        style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
        viewBox="0 0 102 222.348"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        xmlns:xodm="http://www.corel.com/coreldraw/odm/2003"
    >
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.root}"
            @click="select('root')"
            cx="53.062"
            cy="105.36"
            r="9.965"
        />
        <circle
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.periodontitis}"
            @click="select('periodontitis')"
            cx="55.377"
            cy="208.635"
            r="9.965"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.six}"
            @click="select('six')"
            d="M64.501 64.281c-4.657,-2.509 -10.131,-3.072 -16.425,-1.687 -1.126,-7.306 -2.122,-15.645 -2.909,-24.634 -0.91,-10.391 -1.539,-21.651 -1.759,-33.188 2.928,0.497 5.765,0.989 8.01,0.981 2.558,-0.01 5.257,0.034 7.93,0.298 -0.677,12.357 -0.668,23.167 0.029,32.428 0.8,10.646 2.508,19.247 5.124,25.802z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthRight}"
            @click="select('fourthRight')"
            d="M77.876 37.91c-6.492,0.763 -12.658,0.952 -18.499,0.569 -0.697,-9.261 -0.706,-20.071 -0.029,-32.428 7.644,0.755 15.071,3.312 18.347,11.586 1.815,4.582 1.115,12.804 0.181,20.273z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fourthLeft}"
            @click="select('fourthLeft')"
            d="M43.408 4.772c0.22,11.537 0.849,22.797 1.759,33.188 -4.136,-0.803 -6.861,-1.292 -18.453,2.001 -0.915,-13.371 -2.85,-27.637 1.744,-33.972 2.401,-3.312 8.873,-2.25 14.95,-1.217z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdRight}"
            @click="select('thirdRight')"
            d="M64.501 64.281c-2.616,-6.555 -4.324,-15.156 -5.124,-25.802 5.841,0.383 12.007,0.194 18.499,-0.569 -0.44,3.517 -0.931,6.868 -1.236,9.594 -0.902,8.066 -2.553,16.039 -4.904,23.056 -2.14,-2.74 -4.552,-4.833 -7.235,-6.279z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.fifth}"
            @click="select('fifth')"
            d="M48.076 62.594c6.294,-1.385 11.768,-0.822 16.425,1.687 2.683,1.446 5.095,3.539 7.235,6.279 -1.266,3.778 -2.735,7.281 -4.399,10.371 -3.945,7.325 -8.987,12.337 -15.025,13.245 -9.444,-1.798 -17.132,-9.908 -21.444,-22.037 -0.209,-0.59 -0.411,-1.19 -0.605,-1.8 6.529,-3.987 12.466,-6.569 17.813,-7.745z"
        />
        <path
            class="fil1 str1"
            v-if="!noSegments"
            :class="{active:blocks.thirdLeft}"
            @click="select('thirdLeft')"
            d="M45.167 37.96c0.787,8.989 1.783,17.328 2.909,24.634 -4.033,0.887 -8.402,2.574 -13.108,5.061 -1.535,0.806 -3.105,1.697 -4.709,2.672 -1.999,-6.294 -3.125,-13.577 -3.169,-21.557 -0.016,-2.82 -0.17,-5.788 -0.376,-8.801 11.477,-3.25 14.323,-2.806 18.453,-2.009z"
        />
        <path
            class="fil0 str1"
            :class="{redBorder:redBorder}"
            d="M30.868 72.139c1.443,52.993 1.323,99.113 7.297,125.546 6.714,15.492 17.306,12.085 19.774,-14.84 3.005,-32.783 4.253,-68.792 9.398,-101.914m-40.247 -32.161c-0.086,-15.341 -4.262,-35.017 1.368,-42.781 3.559,-4.908 16.058,-0.211 22.96,-0.236 9.87,-0.036 21.856,0.716 26.277,11.884 2.669,6.74 -0.102,21.351 -1.055,29.867 -2.54,22.706 -11.013,44.671 -24.328,46.672 -14.656,-2.79 -25.084,-20.782 -25.222,-45.406z"
        />
    </svg>
</template>

<script>
import { toothMixins } from '@/mixins/tooth.js'
export default {
    mixins: [toothMixins]
}
</script>
